/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VariableValue
 */
export interface VariableValue {
    /**
     * Unique string identifier for the Variable within the Flag
     * @type {string}
     * @memberof VariableValue
     */
    readonly key?: string;
    /**
     * The datatype for the Variable
     * @type {string}
     * @memberof VariableValue
     */
    readonly type?: VariableValueTypeEnum;
    /**
     * The value for the Variable
     * @type {string}
     * @memberof VariableValue
     */
    value: string;
    /**
     * True if the value is currently set to the default_value for the variable definition
     * @type {boolean}
     * @memberof VariableValue
     */
    is_default?: boolean;
    /**
     * Revision number for tracking changes
     * @type {number}
     * @memberof VariableValue
     */
    readonly revision?: number;
}

export function VariableValueFromJSON(json: any): VariableValue {
    return VariableValueFromJSONTyped(json, false);
}

export function VariableValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariableValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': json['value'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
        'revision': !exists(json, 'revision') ? undefined : json['revision'],
    };
}

export function VariableValueToJSON(value?: VariableValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'is_default': value.is_default,
    };
}

/**
* @export
* @enum {string}
*/
export enum VariableValueTypeEnum {
    Boolean = 'boolean',
    String = 'string',
    Double = 'double',
    Integer = 'integer',
    Json = 'json'
}


